import useFetchProjectMembersQuery from '@projectMembers/queries/useFetchProjectMembersQuery';
import Project from 'src/entities/project';
import useFetchCurrentUserQuery from 'src/new_arch/modules/authentication/queries/useFetchCurrentUserQuery';
import useModal from 'src/new_arch/hooks/useModal';

type ShareProjectModalProps = {
	project: Project
	onClose: () => void
};

const defaultModalStyles = {
	inner: { minHeight: '573px' },
	content: { background: 'var(--color-bg-container)' },
	header: { padding: '10px 16px', backgroundColor: 'var(--color-bg-container)' },
	title: { color: 'var(--color-text-primary)' },
	close: { color: 'var(--color-text-primary)' },
	body: { padding: 0 }
};

const useShareProjectModal = ( { project, onClose }: ShareProjectModalProps ) => {
	const { opened, modalStyles } = useModal( {
		name: 'share-project',
		onClose,
		stackOrder: 1,
		defaultStyles: defaultModalStyles,
		preventEscEventBubble: false
	} );

	const { data: currentUser } = useFetchCurrentUserQuery();
	const { data: members } = useFetchProjectMembersQuery( { projectID: project.id } );
	const membersCount = members?.length;
	const useCanEditProject = project.currentUserRole.permissions.currentUserCan( 'edit', 'projects' );

	return {
		opened,
		modalStyles,
		membersCount,
		showManageReviewerRole: useCanEditProject,
		currentUserID: currentUser!.id
	};
};

export default useShareProjectModal;
